import React from "react";
import MoleculeStudio from "./MoleculeStudio";

function App() {
  return <MoleculeStudio />;
}

export default App;